import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslation from "./locales/en.json";
import uaTranslation from "./locales/ua.json";
import czTranslation from "./locales/cz.json";


i18n.use(initReactI18next).init({
  debug: false,
  returnObjects: true,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
  resources: {
    en: {
      translation: enTranslation,
    },
    ua: {
      translation: uaTranslation,
    },
    cz: {
      translation: czTranslation,
    },
  },
});

export default i18n;
